<template>
  <v-app>

    <!-- <TopToolbar  v-if="showNav"></TopToolbar> -->

      <router-view></router-view>

    <BottomNav  v-if="showNav"></BottomNav>

    <div class="update-dialog" v-if="prompt">
      <div class="update-dialog__content">
        Une Nouvelle version est disponible. Recharger pour l'obtenir
      </div>
      <div class="update-dialog__actions">
        <button
          class="update-dialog__button update-dialog__button--confirm"
          @click="update"
        >
          Recharger
        </button>
        <button
          class="update-dialog__button update-dialog__button--cancel"
          @click="prompt = false"
        >
          Anuller
        </button>
      </div>
    </div>
  </v-app>
</template>

<script>
import * as fb from './firebase'
import TopToolbar from './components/TopToolbar.vue'
import BottomNav from './components/BottomNav.vue'

export default {
  data: () => ({
    drawer: false,
    group: null,
    prompt: false
  }),
  components: {
    TopToolbar,
    BottomNav
  },
  methods: {
    async update () {
      this.prompt = false
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' })
    }
  },
  computed: {
    showNav () {
      return (fb.auth.currentUser) // return Object.keys(this.userProfile).length > 1
    }
  },

  watch: {
    group () {
      this.drawer = false
    }
  },
  created () {

  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #bdddbf ;
}

</style>



// WEBPACK FOOTER //
// src/App.vue